module.exports = __webpack_public_path__ + "static/media/flag-hy.9c943b2f.webp";